import { ASPECT_RATIO, LineProps } from '@/components/Controls/Canvas';
import { Group, Rect, Shape } from 'react-konva';
import innerFrame from '@/assets/images/frame/inner-selected.svg';
import inner from '@/assets/images/frame/inner.svg';
import outer from '@/assets/images/frame/outer.svg';
import outerSelected from '@/assets/images/frame/outer-selected.svg';
import { DEFAULT_BORDER_SIZE, DEFAULT_CORNER_RADIUS } from '@/components/Host/PlayersCards';

const cardFrameInner = new Image();
cardFrameInner.src = inner;

const cardFrameInnerSelected = new Image();
cardFrameInnerSelected.src = innerFrame;

const cardFrameOuter = new Image();
cardFrameOuter.src = outer;

const cardFrameOuterSelected = new Image();
cardFrameOuterSelected.src = outerSelected;

const scalePoint = (point: number, originalSize: number, newSize: number) => {
  return (point / originalSize) * newSize;
};

export function DrawPlayerImage({
  drawing,
  cardSize
}: {
  drawing: any;
  cardSize: { width: number; height: number };
}) {
  return (
    <Group
      x={-cardSize.width / 2}
      y={-cardSize.height / 2}
      width={cardSize.width}
      height={cardSize.height}
    >
      <Group>
        <Group
          clipFunc={(ctx) => {
            // Note: These values are derived from the inner.svg's rectangle and ensure
            //       that player image is drawn within the inner frame.
            const margin = 0; // Margin value
            const radius = DEFAULT_CORNER_RADIUS * cardSize.width; // Radius of the corners
            const x = margin; // Starting x position with margin
            const y = margin; // Starting y position with margin
            const width = cardSize.width; // Width of the rectangle with margin
            const height = width / ASPECT_RATIO; // Height of the rectangle with margin

            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            ctx.lineTo(x + width - radius, y);
            ctx.arcTo(x + width, y, x + width, y + radius, radius);
            ctx.lineTo(x + width, y + height - radius);
            ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius);
            ctx.lineTo(x + radius, y + height);
            ctx.arcTo(x, y + height, x, y + height - radius, radius);
            ctx.lineTo(x, y + radius);
            ctx.arcTo(x, y, x + radius, y, radius);
            ctx.closePath();
            ctx.clip();
          }}
        >
          <Rect
            width={cardSize.width}
            height={cardSize.height}
            opacity={100}
            fill={'#FFFFFF'}
            cornerRadius={DEFAULT_CORNER_RADIUS * cardSize.width}
          />
          {drawing.map((line: LineProps, i: number) => (
            <Shape
              key={i}
              sceneFunc={(context, shape) => {
                context.beginPath();
                const scaledPoints = line.points.map((point, index) =>
                  index % 2 === 0
                    ? scalePoint(point, line.canvasWidth, cardSize.width)
                    : scalePoint(point, line.canvasHeight, cardSize.height)
                );

                context.moveTo(scaledPoints[0], scaledPoints[1]);

                for (let j = 2; j < scaledPoints.length; j += 2) {
                  context.quadraticCurveTo(
                    scaledPoints[j - 2],
                    scaledPoints[j - 1],
                    (scaledPoints[j - 2] + scaledPoints[j]) / 2,
                    (scaledPoints[j - 1] + scaledPoints[j + 1]) / 2
                  );
                }

                context.quadraticCurveTo(
                  scaledPoints[scaledPoints.length - 2],
                  scaledPoints[scaledPoints.length - 1],
                  scaledPoints[scaledPoints.length - 2] + 0.5,
                  scaledPoints[scaledPoints.length - 1]
                );

                context.fillStrokeShape(shape);
              }}
              stroke={line.stroke}
              strokeWidth={(line.width / line.canvasWidth) * cardSize.width}
              tension={0}
              lineCap="round"
              lineJoin="round"
            />
          ))}
          <Rect
            width={cardSize.width}
            height={cardSize.height}
            opacity={100}
            stroke={'#d3d3d3'}
            strokeWidth={Math.ceil(DEFAULT_BORDER_SIZE * cardSize.width) * 2}
            cornerRadius={DEFAULT_CORNER_RADIUS * cardSize.width}
          />
        </Group>
      </Group>
    </Group>
  );
}
